var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { defaultStepProps } from './defaults';
import { SuccessOutlined, ErrorOutlined } from '@feb-team/legao-icons-react';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
function isString(str) {
    return typeof str === 'string';
}
var Step = /** @class */ (function (_super) {
    __extends(Step, _super);
    function Step(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a = _this.props, onClick = _a.onClick, onStepClick = _a.onStepClick, stepIndex = _a.stepIndex;
            if (onClick) {
                onClick.apply(void 0, __spread(args));
            }
            onStepClick && onStepClick(stepIndex);
        };
        return _this;
    }
    Step.prototype.renderIconNode = function () {
        var _a;
        var _b = this.props, stepNumber = _b.stepNumber, status = _b.status, icon = _b.icon, active = _b.active, isV = _b.isV, size = _b.size;
        var iconBaseCls = ['absolute', 'z-10', 'top-0', 'flex', 'justify-center'];
        var setSize = size ? size : 'normal';
        var iconSizeMap = {
            small: {
                iconKey: isV
                    ? ['w-px-16', 'h-px-16', 'text-base', 'leading-4']
                    : ['w-full', 'h-px-16', 'text-base', 'leading-4'],
                numKey: ['w-px-16', 'h-px-16'],
            },
            normal: {
                iconKey: isV
                    ? ['w-px-24', 'h-px-24', 'text-2xl', 'leading-6']
                    : ['w-full', 'h-px-24', 'text-2xl', 'leading-6'],
                numKey: ['w-px-24', 'h-px-24'],
            },
        };
        var iconCls = __spread(iconBaseCls, iconSizeMap[setSize].iconKey);
        var hasSvgCls = ['align-top'];
        var txtCls = active && status !== 'wait'
            ? ['border-brand-600', 'bg-brand-600', 'text-white', 'rounded-full', 'border-2']
            : ['border-gray-500', 'rounded-full', 'text-gray-400', 'bg-white'];
        var setIconCls = classNames((_a = {},
            _a['text-brand-600'] = status === 'finish',
            _a['text-error-900'] = status === 'error',
            _a));
        var iconNode;
        if (icon && !isString(icon)) {
            iconNode = (React.createElement(DivTag, { atomics: __spread(iconCls, hasSvgCls, [setIconCls]), autoPrefixedClassName: "step-icon-inner" },
                React.createElement(SpanTag, { atomics: "bg-white" }, icon)));
        }
        else if (status === 'finish') {
            iconNode = (React.createElement(DivTag, { atomics: __spread(iconCls, hasSvgCls, ['text-brand-600']), autoPrefixedClassName: "step-icon-inner" },
                React.createElement(SpanTag, { atomics: "bg-white" },
                    React.createElement(SuccessOutlined, { className: "align-top" }))));
        }
        else if (status === 'error') {
            iconNode = (React.createElement(DivTag, { atomics: __spread(iconCls, hasSvgCls, ['text-error-900']), autoPrefixedClassName: "step-icon-inner" },
                React.createElement(SpanTag, { atomics: "bg-white" },
                    React.createElement(ErrorOutlined, { className: "align-top" }))));
        }
        else {
            iconNode = (React.createElement(DivTag, { atomics: __spread(iconCls), autoPrefixedClassName: "step-icon-inner" },
                React.createElement(DivTag, { atomics: __spread(txtCls, iconSizeMap[setSize].numKey, [
                        'border',
                        'text-sm',
                        'text-center',
                        'inline-flex',
                        'items-center',
                        'justify-center',
                    ]), autoPrefixedClassName: "step-num" }, stepNumber)));
        }
        return iconNode;
    };
    Step.prototype.render = function () {
        var _a, _b, _c, _d;
        var _e = this.props, description = _e.description, title = _e.title, active = _e.active, stepNumber = _e.stepNumber, status = _e.status, icon = _e.icon, className = _e.className, isV = _e.isV, isLast = _e.isLast, size = _e.size, stepIndex = _e.stepIndex, onClick = _e.onClick, onStepClick = _e.onStepClick, disabled = _e.disabled, rest = __rest(_e, ["description", "title", "active", "stepNumber", "status", "icon", "className", "isV", "isLast", "size", "stepIndex", "onClick", "onStepClick", "disabled"]);
        var setSize = size ? size : 'normal';
        var descCls = 'text-xs';
        var sizeMap = {
            small: {
                customKey: !isV ? ['w-px-138', 'pt-7'] : ['w-px-138', 'pb-7'],
                lineKey: !isV ? 'translate-y-2' : 'translate-x-2',
                titleKey: 'text-sm',
            },
            normal: {
                customKey: !isV ? ['w-px-178', 'pt-8'] : ['w-px-178', 'pb-8'],
                lineKey: !isV ? 'translate-y-3' : 'translate-x-3',
                titleKey: 'text-base',
            },
        };
        var lineCls = !isV
            ? ['absolute', 'left-0', 'top-0', 'h-px', 'w-full', 'transform', '-translate-x-1/2']
            : [
                'absolute',
                'left-0',
                'w-px',
                'h-full',
                'top-0',
                'transform',
                '-translate-y-full',
                '-ml-px-1',
                'mt-px-1',
            ];
        var mainCls = !isV ? ['text-center'] : ['pl-8', 'text-left'];
        var isError = status === 'error' && active;
        var accessibilityProps = {};
        if (onStepClick && !disabled) {
            accessibilityProps.role = 'button';
            accessibilityProps.tabIndex = 0;
            accessibilityProps.onClick = this.onClick;
        }
        var setLineClsString = classNames(sizeMap[setSize].lineKey, (_a = {},
            _a['hidden'] = stepNumber === 1,
            _a['bg-error-900'] = isError,
            _a['bg-brand-600'] = status === 'finish' || (active && status !== 'wait'),
            _a['bg-gray-500'] = !(status === 'finish' || (active && status !== 'wait')),
            _a));
        var setLineCusCls = classNames((_b = {},
            _b['error-line'] = isError,
            _b['curr-line'] = status === 'finish' || (active && status !== 'wait'),
            _b));
        var setLineClsArr = setLineClsString.split(/\s/g);
        var lineClss = __spread(setLineClsArr, lineCls);
        var stepClsString = classNames((_c = {},
            _c['text-gray-700'] = status !== 'error' && active,
            _c['text-gray-600'] = status === 'finish' || !active,
            _c['text-error-900'] = isError,
            _c['cursor-not-allowed'] = disabled,
            _c['cursor-pointer'] = onStepClick && !disabled,
            _c));
        var setStepCusCls = classNames(className, (_d = {},
            _d['doing-step'] = active,
            _d['done-step'] = status === 'finish',
            _d['error-step'] = isError,
            _d['disabled-step'] = disabled,
            _d));
        var stepCls = stepClsString.split(/\s/g);
        return (React.createElement(DivTag, __assign({ name: Step.NAME, atomics: __spread(['relative'], sizeMap[setSize].customKey, stepCls), className: setStepCusCls }, rest),
            React.createElement(DivTag, __assign({}, accessibilityProps, { autoPrefixedClassName: "step-icon" }), this.renderIconNode()),
            React.createElement(DivTag, { atomics: mainCls, autoPrefixedClassName: "step-text-x" },
                React.createElement(DivTag, { atomics: [sizeMap[setSize].titleKey, 'font-normal', 'truncate'], autoPrefixedClassName: "step-title" }, title),
                description && (React.createElement(DivTag, { atomics: [descCls, 'break-word'], autoPrefixedClassName: "step-desc" }, description))),
            React.createElement(DivTag, { atomics: lineClss, className: setLineCusCls, autoPrefixedClassName: "step-line" })));
    };
    Step.defaultProps = defaultStepProps;
    Step.NAME = 'step';
    return Step;
}(PureComponent));
export { Step };
